module.exports = __webpack_public_path__ + "img/my_prize_2021.8875106f.png";